var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useEffect, useMemo } from 'react';
import { useForm } from 'react-hook-form';
import { BigTitleModal, ConsentFormModal, HookFormInputs } from 'renderer/components';
import { CustomerConsentFormType } from 'renderer/models/CustomerConsentFormModel';
import { ConsentQuery } from 'renderer/queries';
import styled from 'styled-components';
export var ConsentWriteModal = function (_a) {
    var _b, _c, _d;
    var open = _a.open, onClose = _a.onClose, storeId = _a.storeId, customer = _a.customer;
    var query = ConsentQuery.useConsentTemplates(storeId, { enabled: !!storeId });
    var templates = (_b = query.data) !== null && _b !== void 0 ? _b : [];
    var options = useMemo(function () {
        return templates.map(function (_a) {
            var title = _a.title, id = _a.id;
            return ({
                label: title,
                value: id
            });
        });
    }, [templates]);
    var defaultValues = {
        id: (_c = templates[0]) === null || _c === void 0 ? void 0 : _c.id,
        title: (_d = templates[0]) === null || _d === void 0 ? void 0 : _d.title
    };
    var form = useForm({
        defaultValues: defaultValues,
        mode: 'onChange',
    });
    var _e = React.useState(), drawer = _e[0], setDrawer = _e[1];
    var handleClose = function () {
        setDrawer(undefined);
    };
    var getTemplate = function (id) {
        return templates.find(function (item) { return item.id === id; });
    };
    var handleOk = function () {
        var id = form.getValues('id');
        setDrawer(__assign(__assign({}, getTemplate(id)), { title: form.getValues('title'), templateId: id, type: CustomerConsentFormType.CONSENT, customerId: customer.id, customer: customer, signatureMethod: 'direct' }));
    };
    useEffect(function () {
        if (open) {
            form.reset(defaultValues);
        }
    }, [open]);
    return (React.createElement(React.Fragment, null,
        React.createElement(BigTitleModal, { centered: true, title: "\uB3D9\uC758\uC11C \uC9C1\uC811\uC791\uC131", width: "360px", open: open, cancelText: "\uB2EB\uAE30", onCancel: onClose, okText: "\uC5F4\uAE30", okButtonProps: {
                disabled: !form.formState.isValid
            }, onOk: handleOk },
            React.createElement(StyledForm, null,
                React.createElement("div", null,
                    React.createElement(HookFormInputs.SelectInput, { label: "\uB3D9\uC758\uC11C \uC885\uB958", inputProps: {
                            placeholder: '동의서 종류 선택',
                            options: options,
                            onChange: function (value) {
                                form.setValue('title', getTemplate(value).title, { shouldValidate: true });
                            }
                        }, controlProps: {
                            name: 'id',
                            control: form.control,
                            rules: { required: '동의서 종류를 선택해주세요.' }
                        } })),
                React.createElement("div", null,
                    React.createElement(HookFormInputs.Text, { label: "\uB3D9\uC758\uC11C \uC81C\uBAA9", controlProps: {
                            name: 'title',
                            control: form.control,
                            rules: {
                                required: '제목을 입력해주세요.',
                                maxLength: {
                                    value: 15,
                                    message: '제목은 15자를 넘을 수 없습니다.'
                                }
                            }
                        }, inputProps: {
                            placeholder: '제목을 입력해주세요.'
                        } })))),
        React.createElement(ConsentFormModal, { visible: !!drawer, onClose: handleClose, drawer: drawer })));
};
var StyledForm = styled.form(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: 0 20px 12px;\n  border: var(--Components-Card-Global-lineWidth, 1px) solid var(--Components-Card-Global-colorBorderSecondary, #F0F0F0);\n  border-radius: var(--Components-Card-Global-borderRadiusLG, 8px);\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  row-gap: var(--Components-Card-Global-marginXS, 8px);\n  & .ant-select {\n    width: 100%;\n  }\n  & .ant-input {\n    font-size: 14px !important;\n  }\n"], ["\n  margin: 0 20px 12px;\n  border: var(--Components-Card-Global-lineWidth, 1px) solid var(--Components-Card-Global-colorBorderSecondary, #F0F0F0);\n  border-radius: var(--Components-Card-Global-borderRadiusLG, 8px);\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  row-gap: var(--Components-Card-Global-marginXS, 8px);\n  & .ant-select {\n    width: 100%;\n  }\n  & .ant-input {\n    font-size: 14px !important;\n  }\n"])));
var templateObject_1;
